export default __webpack_public_path__ + "static/media/320x320.3f5677e5.jpg";